function initOfferStrips(scope) {
  var sections = (scope || document).querySelectorAll('[data-offer-strip]');

  sections.forEach(function (section) {
    if (section.dataset.offerInit === 'true') return;

    var swiperEl = section.querySelector('[data-offer-swiper]');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    section.dataset.offerInit = 'true';

    var perViewMobile = parseInt(section.dataset.perViewMobile, 10) || 1;
    var perViewDesktop = parseInt(section.dataset.perViewDesktop, 10) || 2;
    var autoplayDelay = parseInt(section.dataset.autoplayDelay, 10) || 4000;
    var pauseOnHover = section.dataset.pauseHover === 'true';

    var totalSlides = swiperEl.querySelectorAll('.swiper-slide').length;
    // Looping only makes sense once there's more content than fits on
    // screen at once — otherwise Swiper can render slides at the wrong
    // width, which is what caused the stretched card before.
    var canLoop = totalSlides > perViewDesktop;

    // eslint-disable-next-line no-undef
    new Swiper(swiperEl, {
      slidesPerView: perViewMobile,
      spaceBetween: 16,
      loop: canLoop,
      speed: 700,
      autoplay: canLoop
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: pauseOnHover
          }
        : false,
      allowTouchMove: true,
      grabCursor: true,
      breakpoints: {
        750: {
          slidesPerView: perViewDesktop,
          spaceBetween: 24
        }
      }
    });
  });
}

function bootOfferStrips(scope) {
  if (typeof Swiper === 'undefined') {
    window.setTimeout(function () { bootOfferStrips(scope); }, 100);
    return;
  }
  initOfferStrips(scope || document);
}

document.addEventListener('DOMContentLoaded', function () {
  bootOfferStrips(document);
});

document.addEventListener('shopify:section:load', function (event) {
  var section = event.target.querySelector('[data-offer-strip]');
  if (section) section.dataset.offerInit = '';
  bootOfferStrips(event.target);
});